import React, { Component } from 'react';
import ReportSubscriberComponent from '../components/reportSubscriberComponent';
import {UpdateReportTypeSettings,getCountryListFunc,getAllRegionSettings1,getUserListByRegionId, IsEmailEnabled,getAllRegionSettings,PerUserPdfMail} from '../action/reportSubscriberAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
export class ReportSubscriberContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getCountryListFunc(
               this.props.dispatch)
        this.props.actions.getAllRegionSettings();
         
      /*   setTimeout(
            () => this.getMonthlyReport({
            RegionId:this.props.MonthlyReportData.regionList[0].ID
         }),
            400
        ); */
        
    }
    getRegion = () =>{
        this.props.actions.getAllRegionSettings(
            this.props.dispatch
        )
        
    }
   UpdateReportTypeSetting = (item) => {
                    this.props.actions.UpdateReportTypeSettings(
                        item,
                        this.props.dispatch
                    )
            
                
                }
   getRegionData = () => {
          this.props.actions.getAllRegionSettings(this.props.dispatch);
       } 
  getRegionData1 = () => {
          this.props.actions.getAllRegionSettings1(this.props.dispatch);
       }
    getUserList = (data) =>{
        this.props.actions.getUserListByRegionId(data,
            this.props.dispatch
        )
                setTimeout(() => {
        this.getRegionData1()
    }, 700)
    }
  
   getUserListData = (data) => {
          this.props.actions.getUserListByRegionId(data,this.props.dispatch);
       } 
    EnableMap = (item) => {
           this.props.actions.IsEmailEnabled(
               item,
               this.props.dispatch
           )
       }
       PerUserPdfEmail = (item) => {
           this.props.actions.PerUserPdfMail(
               item,
               this.props.dispatch
           )
       }
    render(){
        
        return(
            <div >
                <ReportSubscriberComponent
                    ReportSubscriberDetails = {this.props.ReportSubscriberData}
                    getRegion ={this.getRegion}
                    getRegionList={this.getRegionData}
                    getRegionList1={this.getRegionData1}
                    getUserList ={this.getUserList}
                    enableMap={this.EnableMap}
                    PerUserPdfEmail={this.PerUserPdfEmail}
                    UpdateReportTypeSetting={this.UpdateReportTypeSetting}
                >
                </ReportSubscriberComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllRegionSettings,
            getAllRegionSettings1,
            getUserListByRegionId,
            IsEmailEnabled,
            getCountryListFunc,
            PerUserPdfMail,
            UpdateReportTypeSettings
        },
            dispatch)
    };
}
function mapStateToProps({ ReportSubscriberReducer }) {
    console.log(ReportSubscriberReducer);
    return {
        ReportSubscriberData : {
            errorCode : ReportSubscriberReducer.errorCode,
            statusCode : ReportSubscriberReducer.statusCode,
            regionList : ReportSubscriberReducer.regionList,
            message : ReportSubscriberReducer.message,
            userList:ReportSubscriberReducer.userList,
            countryList : ReportSubscriberReducer.countryList,
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportSubscriberContainer));